import React from 'react'
import {useSelector, useDispatch, shallowEqual} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {FiMenu, FiSun, FiMoon} from 'react-icons/fi'
import Dropdown5 from './dropdown-5'
import AreaSelector from '../../pages/ENIGOOTurnstiles/components/AreaSelector'
//import Dropdown6 from './dropdown-6'
//import Search from './search'
import '../../css/components/navbar.css'
import {setGlobalTheme} from '../../reducers/palettes'

const ENIGOO_PREFIXES = [
  '/enigoo-turnstile',
  '/turnstile', '/turnstile-dashboard', '/turnstile/template', '/turnstile/command',
  '/tariff', '/device', '/ticket', '/entrance',
  '/zone', '/access', '/system-info', '/face-recognition',
]
const isEnigooPage = (pathname) =>
  ENIGOO_PREFIXES.some(p => pathname === p || pathname.startsWith(p + '/'))

const Navbar = () => {
  const {config, dark} = useSelector(
    state => ({config: state.config, dark: state.palettes?.background === 'dark'}),
    shallowEqual
  )
  let {collapsed} = {...config}
  const dispatch = useDispatch()
  const {pathname} = useLocation()

  return (
    <div className="navbar navbar-1 border-b">
      <div className="h-16 navbar-inner w-full flex items-center justify-start">
        <button
          onClick={() =>
            dispatch({type: 'SET_CONFIG_KEY', key: 'collapsed', value: !collapsed})
          }
          className="mx-4 text-grey-600 dark:text-grey-300">
          <FiMenu size={20} />
        </button>

        <span className="ml-auto"></span>

        {/* <button
          type="button"
          title={dark ? 'Světlý režim' : 'Tmavý režim'}
          onClick={() => dispatch(setGlobalTheme(dark ? 'light' : 'dark'))}
          style={{width: '2.25rem', height: '2.25rem', marginRight: '12px'}}
          className="flex items-center justify-center rounded-full
                     bg-grey-100 text-grey-600 hover:bg-grey-200
                     dark:bg-grey-800 dark:text-grey-300 dark:hover:bg-grey-700
                     transition-colors focus:outline-none">
          {dark ? <FiSun size={16}/> : <FiMoon size={16}/>}
        </button>*/}

        {isEnigooPage(pathname) && (
          <div style={{marginRight: '12px'}}>
            <AreaSelector compact/>
          </div>
        )}
        {/*<Dropdown5 />*/}
      </div>
    </div>
  )
}

export default Navbar
